export default __webpack_public_path__ + "static/media/bg-01.eefda8b7.jpg";